export default {
  data: () => ({
    order: {}
  }),

  computed: {
    isLoadedOrder() {
      return Object.keys(this.order).length;
    }
  }
};
